import clsx from 'clsx';
import React, { ReactNode } from 'react';

type SidebarLayoutProps = {
  className?: string;
  children: ReactNode;
  sidebarRef: React.RefObject<HTMLDivElement>;
};

const SidebarLayout = ({ className, sidebarRef, children }: SidebarLayoutProps) => {
  return (
    <div
      className={clsx(
        'card--sidebarEntryList',
        // 'tw-overflow-y-auto tw-scroll-styles',
        'tw-overflow-hidden tw-relative',
        'tw-border-r-[1px] tw-border-r-solid tw-border-r-cfo-grey-500',
        'tw-w-full',
        className
      )}
      ref={sidebarRef}
    >
      {children}
    </div>
  );
};

export default SidebarLayout;
